import styled from "styled-components"

export const LabelWrap = styled.div`
  padding: 0.5rem 0;
  text-align: center;
`

export const Svg = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  vector-effect: non-scaling-stroke;
`

export const TrafficLightWrap = styled.div<{ size: number }>`
  width: ${({ size }) => size}px;
`

export const LightWrap = styled.div<{ size: number }>`
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column nowrap;
  user-select: none;
  position: relative;
`

export const IconWrap = styled.div<{
  size: number
  color: string
}>`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 50%;
  top: 50%;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  margin: ${({ size }) => `${-size / 2}px 0 0 ${-size / 2}px`};
  border-radius: 50%;
  background: radial-gradient(rgb(0 0 0 / 30%) 10%, transparent 50%);
`
